module.exports = __webpack_public_path__ + "img/00015.14f0fe54.webp";